// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';

export const ButtonFeature = t.struct({
    label: t.maybe(t.String),
    show: t.Boolean
}, {
    defaultProps: {
        show: true
    },
    name: 'ButtonFeature'
});
